import * as React from "react";
import { StyleObject } from "styletron-react";
import { Checkbox as BaseCheckbox, CheckboxProps, STYLE_TYPE } from "baseui/checkbox";

import { expandBorder, expandBorderRadius, expandMargin } from "../utils/styles";
import { mergeOverrides } from "baseui";

/* eslint-disable react/prop-types */
// TODO: Enable the proptype check next time when this file is changed

export const Checkbox: React.FC<CheckboxProps> = (props) => {
  const { onChange, value, checked, ...restProps } = props;
  function handleChange(e) {
    onChange?.(e.target.checked);
  }
  const _checked = checked === undefined ? value : checked;

  return (
    <BaseCheckbox
      {...restProps}
      overrides={mergeOverrides(
        {
          Label: {
            style: ({ $theme, $checked }): StyleObject => ({
              ...$theme.typography.ParagraphSmall,
              color: $theme.colors.mono700,
              paddingLeft: $theme.sizing.scale600,
              fontWeight: $checked ? 600 : 300,
            }),
          },
          Checkmark: {
            style: ({ $theme, $checked }): StyleObject => {
              const checkmark = encodeURIComponent(`
              <svg width="17" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 7.7782L4.53553 11.3137L10.0914 5.75789" stroke="${$theme.colors.contentInversePrimary}" stroke-width="2" stroke-linejoin="round"/>
              </svg>
            `);
              return {
                backgroundImage: $checked
                  ? `url('data:image/svg+xml,${checkmark}')`
                  : null,
                backgroundPosition: "2px 0",
                width: "22px",
                height: "22px",
                ...expandBorder("1px", "Width"),
                ...expandBorder(
                  $checked ? "transparent" : $theme.colors.contentTertiary,
                  "Color"
                ),
                ...expandBorderRadius("2px"),
                ...expandMargin(0),
                ...($checked && { backgroundColor: $theme.colors.primary }),
              };
            },
          },
          ToggleTrack: {
            style: styleToggleTrack,
          },
        },
        restProps?.overrides
      )}
      onChange={handleChange}
      onMouseDown={(e) => e.preventDefault()}
      checked={_checked}
    />
  );
};

const styleToggleTrack = ({ $theme, $checked }): StyleObject => ({
  width: "44px",
  height: "24px",
  paddingLeft: "3px",
  ...expandBorderRadius("12px"),
  ...($checked && { backgroundColor: $theme.colors.contentTertiary }),
});

Checkbox.STYLE_TYPE = STYLE_TYPE;
